module.exports = "<span [matTooltip]=\"content\"><i class=\"material-icons\">info_outline</i></span>\n"